import { RULES_CONSTANT } from 'constant/RuleConstant';
import { FieldValidationValues } from '../types';

export const VALIDATION_PATTERN_OPTIONS = [
  { label: 'None', value: null },
  { label: 'Email', value: 'VALIDATION_PATTERN_EMAIL' },
  { label: 'Website URL', value: 'VALIDATION_PATTERN_URL' },
  { label: 'Text Description', value: 'VALIDATION_PATTERN_TEXT_DESCRIPTION' },
  { label: 'Custom Pattern', value: 'VALIDATION_PATTERN_CUSTOM' },
];

const VALIDATION_RULES = new Set([
  RULES_CONSTANT.TEXT.RULE_INPUT,
  RULES_CONSTANT.BASE_SUBJECT.RULE_ATTRIBUTE_SUBJECT_BASE,
  RULES_CONSTANT.TEXT.RULE_CHAR_LIMIT,
]);

export function supportsFieldValidation(ruleTypeCode?: string) {
  return Boolean(ruleTypeCode && VALIDATION_RULES.has(ruleTypeCode));
}

export function parseFieldValidation(validationPattern?: string | null): FieldValidationValues {
  if (!validationPattern) {
    return {
      validationPattern: null,
      minCharacter: null,
      maxCharacter: 255,
      noSpace: false,
      noSpecialCharacter: false,
    };
  }

  try {
    const parsed = JSON.parse(validationPattern);
    return {
      validationPattern: parsed.validationPattern ?? null,
      minCharacter: parsed.minCharacter ?? null,
      maxCharacter: parsed.maxCharacter ?? 255,
      noSpace: Boolean(parsed.noSpace),
      noSpecialCharacter: Boolean(parsed.noSpecialCharacter),
    };
  } catch {
    return {
      validationPattern: null,
      minCharacter: null,
      maxCharacter: 255,
      noSpace: false,
      noSpecialCharacter: false,
    };
  }
}

export function serializeFieldValidation(values: FieldValidationValues) {
  return JSON.stringify({
    validationPattern: values.validationPattern,
    minCharacter: values.minCharacter ?? 0,
    maxCharacter: values.maxCharacter ?? 255,
    noSpace: values.noSpace,
    noSpecialCharacter: values.noSpecialCharacter,
  });
}

export function isFieldValidationValid(values: FieldValidationValues) {
  if (values.validationPattern !== 'VALIDATION_PATTERN_CUSTOM') return true;
  const min = values.minCharacter;
  const max = values.maxCharacter;
  if (min !== null && min < 0) return false;
  if (max !== null && (max <= 0 || max > 255)) return false;
  return min === null || max === null || min <= max;
}

